import config from 'src/lib/config'
import styled from 'styled-components'

interface ButtonProps {
	children?: any
	secondary?: boolean
	[x:string]: any
}

const Button = ({ children, secondary = false, ...rest }: ButtonProps) => (
	<StyledButton color={secondary ? '#E0EFE4' : '#98EDB1'} {...rest}>
		{children}
	</StyledButton>
)

// TODO: secondary hover effect color
const StyledButton = styled.button(
	(props) => `
		background: ${props.color};
		border: none;
		border-radius: 200px;
		padding: ${Math.round(25 * config.resize)}px ${Math.round(50 * config.resize)}px;
		font-size: ${Math.round(32 * config.resize)}px;
		font-family: "GothamBold";
		color: #08372E;
		box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.05);
		transition: background-color 0.3s, transform 0.2s;
		&:hover, &:active {
			background: #adf1c1;
			transform: translateY(-2px);
			cursor: pointer;
		}
	`,
)

export default Button
